import React, { useState, useEffect } from "react";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import useCadastro from "../../hooks/useCadastroContext";

const animatedComponents = makeAnimated();

const optionsEmpresas = [
  { value: 'A3 DATA', label: 'A3 DATA' },
  { value: 'ALVAREZ & MARSAL', label: 'ALVAREZ & MARSAL' },
  { value: 'BARRFAB', label: 'BARRFAB' },
  { value: 'BD-BECTON DICKINSON', label: 'BD-BECTON DICKINSON' },
  { value: 'BIONEXO S.A.', label: 'BIONEXO S.A.' },
  { value: 'CLICKNURSE', label: 'CLICKNURSE' },
  { value: 'CLOUD SAUDE', label: 'CLOUD SAUDE' },
  { value: 'CUSHMAN & WAKEFIELD', label: 'CUSHMAN & WAKEFIELD' },
  { value: 'DANONE', label: 'DANONE' },
  { value: 'DOCTOR TIS', label: 'DOCTOR TIS' },
  { value: 'ECOLIMP', label: 'ECOLIMP' },
  { value: 'EY', label: 'EY' },
  { value: 'FOLKS', label: 'FOLKS' },
  { value: 'GETINGE DO BRASIL', label: 'GETINGE DO BRASIL' },
  { value: 'GLOBALTHINGS', label: 'GLOBALTHINGS' },
  { value: 'GRUPO DOC', label: 'GRUPO DOC' },
  { value: 'GRUPO PRIME MED', label: 'GRUPO PRIME MED' },
  { value: 'HTB ENGENHARIA', label: 'HTB ENGENHARIA' },
  { value: 'INDIGO', label: 'INDIGO' },
  { value: 'INOVA PHARMA', label: 'INOVA PHARMA' },
  { value: 'INTELECTAH', label: 'INTELECTAH' },
  { value: 'KONIMAGEM', label: 'KONIMAGEM' },
  { value: 'LIBBS', label: 'LIBBS' },
  { value: 'MAX EMERGENCIAS', label: 'MAX EMERGENCIAS' },
  { value: 'META HOSPITALAR', label: 'META HOSPITALAR' },
  { value: 'MV', label: 'MV' },
  { value: 'NILO', label: 'NILO' },
  { value: 'RHOPEN', label: 'RHOPEN' },
  { value: 'RTS', label: 'RTS' },
  { value: 'SALESFORCE', label: 'SALESFORCE' },
  { value: 'SINCRON', label: 'SINCRON' },
  { value: 'SISNAC', label: 'SISNAC' },
  { value: 'SISQUAL', label: 'SISQUAL' },
  { value: 'SOLVENTUM (3M)', label: 'SOLVENTUM (3M)' },
  { value: 'SPECIAL GASES', label: 'SPECIAL GASES' },
  { value: 'TELA', label: 'TELA' },
  { value: 'TETO', label: 'TETO' },
  { value: 'TOTVS', label: 'TOTVS' },
  { value: 'WHITE MARTINS', label: 'WHITE MARTINS' },
  { value: 'WOLTERS KLUWER', label: 'WOLTERS KLUWER' }
];

const CadastroMatchMeet = () => {
  const { empresaInteresse, setEmpresaInteresse } = useCadastro();
  const [empresasSelecionadas, setEmpresasSelecionadas] = useState([]);
  const [limiteAtingido, setLimiteAtingido] = useState(false);

  useEffect(() => {
    // Carregar empresas já selecionadas se existirem
    if (empresaInteresse) {
      const empresas = empresaInteresse.split('; ').filter(emp => emp.trim());
      const empresasFormatadas = empresas.map(emp => ({
        value: emp,
        label: emp
      }));
      setEmpresasSelecionadas(empresasFormatadas);
      setLimiteAtingido(empresasFormatadas.length >= 3);
    }
  }, [empresaInteresse]);

  const handleSelectEmpresas = (selectedOptions) => {
    // Se não há opções selecionadas, limpar tudo
    if (!selectedOptions) {
      setEmpresasSelecionadas([]);
      setLimiteAtingido(false);
      setEmpresaInteresse("");
      return;
    }

    // Se há mais de 3 opções selecionadas, limitar aos 3 primeiros
    if (selectedOptions.length > 3) {
      const limitedSelection = selectedOptions.slice(0, 3);
      setEmpresasSelecionadas(limitedSelection);
      setLimiteAtingido(true);
      let stringEmpresaInteresse = limitedSelection.map((item) => item.value).join("; ");
      setEmpresaInteresse(stringEmpresaInteresse);
    } else {
      // Atualizar com as opções selecionadas (pode ser menos de 3)
      setEmpresasSelecionadas(selectedOptions);
      setLimiteAtingido(selectedOptions.length === 3);
      let stringEmpresaInteresse = selectedOptions.map((item) => item.value).join("; ");
      setEmpresaInteresse(stringEmpresaInteresse);
    }
  };

  return (
    <>
      <h5 className="texto-cadastro">
        Novidade! Projeto Match-meet
        <br />
        Reservamos um espaço na agenda para que você também tenha a oportunidade de escolher com quem deseja realizar uma reunião. 
        Selecione até 3 empresas e verificaremos a disponibilidade desse agendamento.
      </h5>

      <div className="area-inputs">
        <label className="form-label" htmlFor="input_empresas">
          Com qual empresa você gostaria de conversar durante o evento? (máx. 3)
          {limiteAtingido && (
            <span className="text-red"> - Limite de 3 empresas atingido</span>
          )}
        </label>
        
        <Select
          closeMenuOnSelect={false}
          components={animatedComponents}
          isMulti
          noOptionsMessage={() => "Nenhuma empresa encontrada"}
          options={optionsEmpresas}
          placeholder="Selecione até 3 empresas"
          onChange={handleSelectEmpresas}
          value={empresasSelecionadas}
          menuPosition="fixed"
          menuPlacement="auto"
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
              position: 'absolute'
            })
          }}
        />
        
        {limiteAtingido && (
          <div className="mb-1">
            <small className="text-muted">
              Você selecionou o máximo de 3 empresas. Para alterar, remova uma empresa da lista acima.
            </small>
          </div>
        )}
      </div>
    </>
  );
};

export default CadastroMatchMeet; 